import { render, staticRenderFns } from "./EventsModal.vue?vue&type=template&id=7c99df20&scoped=true&"
import script from "./EventsModal.vue?vue&type=script&lang=ts&"
export * from "./EventsModal.vue?vue&type=script&lang=ts&"
import style0 from "./EventsModal.vue?vue&type=style&index=0&id=7c99df20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c99df20",
  null
  
)

export default component.exports